import { validateSubmissionTask } from '@common/services/submissionTaskService';
import { Id } from '@common/types';
import useWaitingMutation from '@hooks/useWaitingMutation';

export const useValidateSubmissionTask = () => {
  const { mutate } = useWaitingMutation((taskId: Id) => validateSubmissionTask(taskId));

  return { validateSubmissionTask: mutate };
};
